const TIPO_FISCAL_NFE = 'nfe'
const TIPO_FISCAL_NFSE = 'nfse'
const NFSE_PROVIDER_NACIONAL = 'nacional'
const NFSE_PROVIDER_SIMPLISS = 'simpliss'
const NFSE_PROVIDER_SIMPLISS_NACIONAL = 'simpliss_nacional'
const NFSE_PROVIDER_CIDADE360 = 'cidade360'
const NFSE_PROVIDER_ELOTECH = 'elotech'

const DOCUMENTOS_TIPOS_DESCRICOES = {
  [TIPO_FISCAL_NFE]: 'NFe',
  [TIPO_FISCAL_NFSE]: 'NFSe',
}

const TIPO_AMBIENTE_PRODUCAO = 1
const TIPO_AMBIENTE_HOMOLOGACAO = 2

const TIPOS_AMBIENTES_DESCRICOES = {
  [TIPO_AMBIENTE_PRODUCAO]: 'Produção',
  [TIPO_AMBIENTE_HOMOLOGACAO]: 'Homologação',
}

const NFSE_PROVIDER_DESCRICOES = {
  [NFSE_PROVIDER_NACIONAL]: 'Nacional',
  [NFSE_PROVIDER_SIMPLISS]: 'Simpliss',
  [NFSE_PROVIDER_SIMPLISS_NACIONAL]: 'Simpliss - Nacional',
  [NFSE_PROVIDER_CIDADE360]: 'Cidade360',
  [NFSE_PROVIDER_ELOTECH]: 'Elotech',
}

const STATUS_PENDENTE = 1
const STATUS_EMITIDO = 2
const STATUS_CANCELADO = 3
const STATUS_SUBSTITUIDO = 4
const STATUS_ERRO = 5

const OPERACAO_FISCAL_EMISSAO = 'emissao'
const OPERACAO_FISCAL_CANCELAMENTO = 'cancelamento'
const OPERACAO_FISCAL_CARTA_CORRECAO = 'carta_correcao'
const OPERACAO_FISCAL_INUTILIZACAO = 'inutilizacao'
const OPERACAO_FISCAL_CONSULTA = 'consulta'
const OPERACAO_FISCAL_DEVOLUCAO = 'devolucao'
const OPERACAO_FISCAL_CONTINGENCIA = 'contingencia'

const STATUS_OPERACAO_FISCAL_PENDENTE = 'pendente'
const STATUS_OPERACAO_FISCAL_PROCESSANDO = 'processando'
const STATUS_OPERACAO_FISCAL_AUTORIZADO = 'autorizado'
const STATUS_OPERACAO_FISCAL_REJEITADO = 'rejeitado'
const STATUS_OPERACAO_FISCAL_ERRO = 'erro'

const DESCRICAO_STATUS = {
  [STATUS_PENDENTE]: 'Pendente',
  [STATUS_EMITIDO]: 'Emitido',
  [STATUS_CANCELADO]: 'Cancelado',
  [STATUS_SUBSTITUIDO]: 'Substituído',
  [STATUS_ERRO]: 'Erro',
}

const COR_STATUS = {
  [STATUS_PENDENTE]: 'info',
  [STATUS_EMITIDO]: 'success',
  [STATUS_ERRO]: 'error',
  [STATUS_CANCELADO]: 'grey',
  [STATUS_SUBSTITUIDO]: 'success',
}

const OPERACOES_FISCAIS_DESCRICOES = {
  [OPERACAO_FISCAL_EMISSAO]: 'Emissão',
  [OPERACAO_FISCAL_CANCELAMENTO]: 'Cancelamento',
  [OPERACAO_FISCAL_CARTA_CORRECAO]: 'Carta de Correção',
  [OPERACAO_FISCAL_INUTILIZACAO]: 'Inutilização',
  [OPERACAO_FISCAL_CONSULTA]: 'Consulta',
  [OPERACAO_FISCAL_DEVOLUCAO]: 'Devolução',
  [OPERACAO_FISCAL_CONTINGENCIA]: 'Contingência',
}

const STATUS_OPERACOES_FISCAIS_DESCRICOES = {
  [STATUS_OPERACAO_FISCAL_PENDENTE]: 'Pendente',
  [STATUS_OPERACAO_FISCAL_PROCESSANDO]: 'Processando',
  [STATUS_OPERACAO_FISCAL_AUTORIZADO]: 'Autorizado',
  [STATUS_OPERACAO_FISCAL_REJEITADO]: 'Rejeitado',
  [STATUS_OPERACAO_FISCAL_ERRO]: 'Erro',
}

const COR_STATUS_OPERACAO_FISCAL = {
  [STATUS_OPERACAO_FISCAL_PENDENTE]: 'warning',
  [STATUS_OPERACAO_FISCAL_PROCESSANDO]: 'info',
  [STATUS_OPERACAO_FISCAL_AUTORIZADO]: 'green',
  [STATUS_OPERACAO_FISCAL_REJEITADO]: 'deep-orange',
  [STATUS_OPERACAO_FISCAL_ERRO]: 'red',
}

const CFOP_OPERATION_VENDA_REVENDA = 'VENDA_REVENDA'
const CFOP_OPERATION_VENDA_PRODUCAO = 'VENDA_PRODUCAO'
const CFOP_OPERATION_BONIFICACAO = 'BONIFICACAO'
const CFOP_OPERATION_REMESSA = 'REMESSA'
const CFOP_OPERATION_DEVOLUCAO = 'DEVOLUCAO'
const CFOP_OPERATION_INDUSTRIALIZACAO = 'INDUSTRIALIZACAO'
const CFOP_OPERATION_EXPORTACAO = 'EXPORTACAO'
const CFOP_OPERATION_OUTROS = 'OUTROS'

const CFOP_OPERATION_DESCRICOES = {
  [CFOP_OPERATION_VENDA_REVENDA]: 'Venda de mercadoria adquirida',
  [CFOP_OPERATION_VENDA_PRODUCAO]: 'Venda de produção própria',
  [CFOP_OPERATION_BONIFICACAO]: 'Bonificação',
  [CFOP_OPERATION_REMESSA]: 'Remessa',
  [CFOP_OPERATION_DEVOLUCAO]: 'Devolução',
  [CFOP_OPERATION_INDUSTRIALIZACAO]: 'Industrialização',
  [CFOP_OPERATION_EXPORTACAO]: 'Exportação',
  [CFOP_OPERATION_OUTROS]: 'Outros',
}

const CFOP_SOURCE_DESCRICOES = {
  manual: 'Manual',
  operation_rule: 'Regra fiscal',
  product_transformed: 'Produto transformado',
  product_default: 'Produto padrão',
}

export {
  TIPO_FISCAL_NFSE,
  TIPO_FISCAL_NFE,
  NFSE_PROVIDER_NACIONAL,
  NFSE_PROVIDER_SIMPLISS,
  NFSE_PROVIDER_SIMPLISS_NACIONAL,
  NFSE_PROVIDER_CIDADE360,
  NFSE_PROVIDER_ELOTECH,
  NFSE_PROVIDER_DESCRICOES,
  DOCUMENTOS_TIPOS_DESCRICOES,

  TIPO_AMBIENTE_PRODUCAO,
  TIPO_AMBIENTE_HOMOLOGACAO,
  TIPOS_AMBIENTES_DESCRICOES,

  STATUS_PENDENTE,
  STATUS_EMITIDO,
  STATUS_CANCELADO,
  STATUS_SUBSTITUIDO,
  STATUS_ERRO,

  OPERACAO_FISCAL_EMISSAO,
  OPERACAO_FISCAL_CANCELAMENTO,
  OPERACAO_FISCAL_CARTA_CORRECAO,
  OPERACAO_FISCAL_INUTILIZACAO,
  OPERACAO_FISCAL_CONSULTA,
  OPERACAO_FISCAL_DEVOLUCAO,
  OPERACAO_FISCAL_CONTINGENCIA,
  OPERACOES_FISCAIS_DESCRICOES,

  STATUS_OPERACAO_FISCAL_PENDENTE,
  STATUS_OPERACAO_FISCAL_PROCESSANDO,
  STATUS_OPERACAO_FISCAL_AUTORIZADO,
  STATUS_OPERACAO_FISCAL_REJEITADO,
  STATUS_OPERACAO_FISCAL_ERRO,
  STATUS_OPERACOES_FISCAIS_DESCRICOES,
  COR_STATUS_OPERACAO_FISCAL,

  DESCRICAO_STATUS,
  COR_STATUS,

  CFOP_OPERATION_VENDA_REVENDA,
  CFOP_OPERATION_VENDA_PRODUCAO,
  CFOP_OPERATION_BONIFICACAO,
  CFOP_OPERATION_REMESSA,
  CFOP_OPERATION_DEVOLUCAO,
  CFOP_OPERATION_INDUSTRIALIZACAO,
  CFOP_OPERATION_EXPORTACAO,
  CFOP_OPERATION_OUTROS,
  CFOP_OPERATION_DESCRICOES,
  CFOP_SOURCE_DESCRICOES,
}
